import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetMessagingPlusEntitlementQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetMessagingPlusEntitlementQuery = {
  __typename?: 'Query';
  getMessagingSettingsByEventId?: { __typename?: 'MessagingSettings'; id: string; messagingTier?: Types.MessagingTier | null } | null;
};

export const GetMessagingPlusEntitlementDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMessagingPlusEntitlement' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMessagingSettingsByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messagingTier' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMessagingPlusEntitlementQuery__
 *
 * To run a query within a React component, call `useGetMessagingPlusEntitlementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagingPlusEntitlementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagingPlusEntitlementQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMessagingPlusEntitlementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessagingPlusEntitlementQuery, GetMessagingPlusEntitlementQueryVariables>) {
  return ApolloReactHooks.useQuery<GetMessagingPlusEntitlementQuery, GetMessagingPlusEntitlementQueryVariables>(GetMessagingPlusEntitlementDocument, baseOptions);
}
export function useGetMessagingPlusEntitlementLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessagingPlusEntitlementQuery, GetMessagingPlusEntitlementQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetMessagingPlusEntitlementQuery, GetMessagingPlusEntitlementQueryVariables>(GetMessagingPlusEntitlementDocument, baseOptions);
}
export type GetMessagingPlusEntitlementQueryHookResult = ReturnType<typeof useGetMessagingPlusEntitlementQuery>;
export type GetMessagingPlusEntitlementLazyQueryHookResult = ReturnType<typeof useGetMessagingPlusEntitlementLazyQuery>;
export type GetMessagingPlusEntitlementQueryResult = Apollo.QueryResult<GetMessagingPlusEntitlementQuery, GetMessagingPlusEntitlementQueryVariables>;
